import { render, staticRenderFns } from "./date-field.vue?vue&type=template&id=506af460"
import script from "./date-field.vue?vue&type=script&lang=js"
export * from "./date-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('506af460')) {
      api.createRecord('506af460', component.options)
    } else {
      api.reload('506af460', component.options)
    }
    module.hot.accept("./date-field.vue?vue&type=template&id=506af460", function () {
      api.rerender('506af460', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/formControls/date-field.vue"
export default component.exports